import { ESGlossary } from '../../elastic_search'
import { Glossary } from '../../firebase'
import { Designed } from '../../types'
import { MathJax } from '../mathdown/mathjax'
import { ShapedTimestamp } from '../timestamp/ShapedTimestamp'
import { GlossaryTitleLink } from './TitleLink'

type ItemProps = {
  glossary: Glossary | ESGlossary
}

const GlossaryTimestamp = ({ glossary }: ItemProps) => {
  // 検索結果（ESGlossary）はユーザが更新した日時を持たないので、投稿日時だけを出す
  if (!('updated_by_user_at' in glossary))
    return <ShapedTimestamp timestamp={glossary.created_at} />
  // 投稿時は作成と同時に updated_by_user_at も入るので、少し後の更新だけを「更新」とする
  const isUpdated =
    glossary.updated_by_user_at.toMillis() - glossary.created_at.toMillis() >
    60 * 1000
  return (
    <>
      <ShapedTimestamp
        timestamp={
          isUpdated ? glossary.updated_by_user_at : glossary.created_at
        }
      />
      に{isUpdated ? '更新' : '投稿'}
    </>
  )
}

const GlossaryItem = ({ glossary, ...otherProps }: Designed<ItemProps>) => {
  return (
    <div {...otherProps}>
      <h3 className="my-0 fs-5">
        <GlossaryTitleLink glossary={glossary} />
      </h3>
      <MathJax className="my-2 text-truncate-3">{glossary.summary}</MathJax>
      <div className="text-muted small">
        <GlossaryTimestamp glossary={glossary} />
      </div>
    </div>
  )
}

type Props = {
  glossaries: Glossary[] | ESGlossary[]
}

export const GlossaryList = ({
  glossaries,
  ...otherProps
}: Designed<Props>) => {
  return (
    <div {...otherProps}>
      <div className="d-flex flex-column gap-6">
        {glossaries.map((g) => (
          <GlossaryItem key={g.id} glossary={g} />
        ))}
        {glossaries.length === 0 && <>用語の解説がありません。</>}
      </div>
    </div>
  )
}
